import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { map, snakeCase } from 'lodash';

import { FormGroupControl, FormGroupSelect } from '@components/Base';
import { CorporateHealthClaimTypes, getCorporateHealthClaimType } from '@models/CorporateHealthClaim';
import { CorporateHealthOrderUserRemainingBenefit } from '@models/CorporateHealthOrderUserRemainingBenefit';

const GROUP_PROPS = { className: 'mb-3' };

type Props = {
  remainingBenefits?: CorporateHealthOrderUserRemainingBenefit[];
};

const ClaimCardBody = ({ remainingBenefits }: Props) => {
  const { t } = useTranslation();

  return (
    <Card.Body>
      <Card.Title>{t('common:claim')}</Card.Title>
      <Row>
        <Col>
          <FormGroupControl
            type="datetime-local"
            name="accidentHappenedAt"
            label={t('corporateHealthClaimForm.accidentHappenedAt.label')}
            required
            groupProps={GROUP_PROPS}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroupSelect name="claimType" label={t('claimForm.claimType.label')} required groupProps={GROUP_PROPS}>
            <option></option>
            {map(remainingBenefits, ({ healthPlanBenefit: { benefitType }, remainingLimitAmount }) => (
              <option key={benefitType} value={snakeCase(benefitType)} disabled={Number(remainingLimitAmount) <= 0}>
                {getCorporateHealthClaimType(benefitType as CorporateHealthClaimTypes)}
              </option>
            ))}
          </FormGroupSelect>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroupControl
            name="supportingDocuments"
            type="file"
            multiple
            label={t('claimForm.supportingDocuments.label')}
            required
            groupProps={GROUP_PROPS}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroupControl
            name="totalClaimedAmount"
            label={t('claimForm.totalClaimedAmount.label')}
            required
            groupProps={GROUP_PROPS}
          />
        </Col>
      </Row>
    </Card.Body>
  );
};

export { ClaimCardBody };
